import posthog from "posthog-js"
import { isAbortError, isHttpError, isNetworkError } from "@/shared/api/errors"
import { fetchUpdateCheck } from "@/shared/lib/app-update/update-check"
import { requireUpdate } from "@/shared/lib/app-update/update-required"
import type { StoreId } from "@/shared/lib/platform"

export function startBackgroundTasks(store: StoreId | null): void {
	// Forced update gate on the store builds.
	checkUpdateRequired(store)
	// Install attribution on the Google Play / RuStore builds.
	sendInstallReferrer(store)
}

// Install Referrer — lazy-loaded on the Android store builds, fire-and-forget.
function sendInstallReferrer(store: StoreId | null): void {
	if (store !== "google-play" && store !== "rustore") return

	void import("@/features/install-attribution")
		.then((m) => m.sendInstallReferrerOnce())
		.catch((error) => {
			posthog.captureException(error, { scope: "install-referrer.bootstrap" })
		})
}

function checkUpdateRequired(store: StoreId | null): void {
	if (store === null) return

	void fetchUpdateCheck()
		.then((result) => {
			if (result.update_screen) requireUpdate()
		})
		.catch((error: unknown) => {
			if (isNetworkError(error) || isAbortError(error)) return
			if (isHttpError(error) && error.status === 404) return
			posthog.captureException(error, { scope: "update-check" })
		})
}
